import { Text } from '@reveni-io/reveni-ui'

import useCreatePreview from './useCreatePreview/useCreatePreview'
import * as Styles from './styles'

const WidgetPreview = ({
  backgroundColor,
  textColor,
  linkColor,
  loadScriptContainerId,
  widgetContainerId,
  title,
  language,
  customTexts,
}) => {
  useCreatePreview({
    backgroundColor,
    textColor,
    linkColor,
    loadScriptContainerId,
    widgetContainerId,
    language,
    customTexts,
  })

  return (
    <Styles.PreviewContainer>
      <Text type="bodyMBold">{title}</Text>
      <Styles.Preview>
        <div id={loadScriptContainerId}></div>
      </Styles.Preview>
    </Styles.PreviewContainer>
  )
}

export default WidgetPreview
